import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { IconInfo } from '@redteclab/icons'

type ProductFlagVariant = 'filled' | 'outlined'

type ProductFlagProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ProductFlagVariant
}

export const ProductFlag: FC<ProductFlagProps> = ({
  children,
  className,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={clsx('product-flag', className)}
      onClick={onClick}
      type="button"
      {...rest}
    >
      <span>{children}</span>
      <IconInfo className="product-flag__icon" />
    </button>
  )
}
